
const state = () => ({
    birthdays: [],
    patients: []
})

export default state